import React, { useEffect } from "react";
import "./DropContainer.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";

export type TDropValue = "open" | "closed";

interface IProps {
    title: React.ReactNode | undefined;
    description: React.ReactNode | undefined;
    value?: TDropValue | string;
    onClick?: (e) => void;
    disabled?: boolean;
    children?: React.ReactNode;
    replaceIcon?: React.ReactNode;
}

export default function DropContainer(props: IProps) {
    const [value, setValue] = React.useState<TDropValue | string>(props.value || "open");

    const onClick = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (props.onClick) {
            props.onClick(e);
        }

        if (props.disabled) {
            return;
        }

        if (value === "open") {
            setValue("closed");
        } else if (value === "closed") {
            setValue("open");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <div
            className={`userful-drop-container noselect ${
                value === "open" ? "userful-drop-container-open" : ""
            }  ${props.disabled ? "userful-drop-container-disabled" : ""}`}
        >
            <div className="userful-drop-header" onClick={onClick}>
                <div className="userful-drop-text">
                    <h1>{props.title}</h1>
                    <p>{props.description}</p>
                </div>
                <div className="userful-drop-icon">
                    {!props.replaceIcon && <FontAwesomeIcon icon={value === "open" ? faChevronUp : faChevronDown} />}
                    {props.replaceIcon && props.replaceIcon}
                </div>
            </div>
            {value === "open" && <div className="useful-drop-body">{props.children}</div>}
        </div>
    );
}
